import { defineAsyncComponent } from 'vue';
import { mapState } from 'pinia';
import { usePageStore } from '@/store';

export default {
    computed: {
        ...mapState(usePageStore, {
            page: store => store.page
        }),
        searchCom({ page }) {
            return page.searchCenter ? 'SearchMoreCenter' : 'SearchMore';
        },
        searchTag({ page }) {
            return page.searchCenter ? 'SearchTagCenter' : 'SearchTag';
        }
    },
    components: {
        SearchMore: defineAsyncComponent(() => import(/* webpackChunkName: "modules/md-search-bar/broker/search-more" */ './search-more.vue')),
        SearchMoreCenter: defineAsyncComponent(() =>
            import(/* webpackChunkName: "modules/md-search-bar/broker/search-more-center" */ './search-more-center.vue')),
        SearchTag: defineAsyncComponent(() => import(/* webpackChunkName: "modules/md-search-bar/broker/search-tag" */ './search-tag.vue')),
        SearchTagCenter: defineAsyncComponent(() =>
            import(/* webpackChunkName: "modules/md-search-bar/broker/search-tag-center" */ './search-tag-center.vue'))
    }
};
